// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"567":"cdb7d73a","1572":"cdb7d73a","5561":"459a31c6","6518":"a39587de","8188":"cdb7d73a"}[chunkId] + ".chunk.css";
};